import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import fr from './fr';
import en from './en';

const DICOS = { fr, en };
const CLE = 'datasectoriel-langue';

const LangueContext = createContext({ langue: 'fr', t: fr, changerLangue: () => {} });

export const FournisseurLangue = ({ children }) => {
  const [langue, setLangue] = useState(() => {
    if (typeof window === 'undefined') return 'fr';
    const memo = window.localStorage.getItem(CLE);
    if (memo && DICOS[memo]) return memo;
    const nav = (window.navigator.language || 'fr').toLowerCase();
    return nav.startsWith('en') ? 'en' : 'fr';
  });

  const changerLangue = (l) => {
    if (!DICOS[l]) return;
    setLangue(l);
    try {
      window.localStorage.setItem(CLE, l);
    } catch (e) {
      /* stockage indisponible */
    }
  };

  const t = DICOS[langue] || fr;

  useEffect(() => {
    document.documentElement.lang = langue;
    document.title = t.meta.titre;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content', t.meta.description);
  }, [langue, t]);

  const valeur = useMemo(() => ({ langue, t, changerLangue }), [langue, t]);

  return <LangueContext.Provider value={valeur}>{children}</LangueContext.Provider>;
};

export const useLangue = () => useContext(LangueContext);

export default LangueContext;
